import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=3b9b7dac&scoped=true&"
import script from "./nothing.vue?vue&type=script&lang=js&"
export * from "./nothing.vue?vue&type=script&lang=js&"
import style0 from "./nothing.vue?vue&type=style&index=0&id=3b9b7dac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b7dac",
  null
  
)

export default component.exports